import { TablePaginationConfig } from 'antd';
import { SortOrder } from 'antd/lib/table/interface';
import { SerializedMeter } from '@enmon/commons/lib/enmon';
import { SerializedInventoryLocationBuilding } from '@enmon/commons/lib/tools';
import { Commodity } from '@enmon/commons/lib/shared';

export interface MeterListFilter {
  commodities?: Commodity[];
  locationBuildings?: SerializedInventoryLocationBuilding['id'][];
  buildingFloors?: NonNullable<SerializedMeter['buildingFloor']>[];
  serialNumbers?: SerializedMeter['serial'][];
  sortOrder: SortOrder;
  sortField: string;
}

export const DEFAULT_FILTER: MeterListFilter = {
  commodities: undefined,
  locationBuildings: undefined,
  buildingFloors: undefined,
  serialNumbers: undefined,
  sortOrder: 'ascend',
  sortField: 'toolsId',
};

export type MeterListPagination = Required<Pick<TablePaginationConfig, 'pageSize' | 'current' | 'total'>>;

export const DEFAULT_PAGINATION: MeterListPagination = {
  current: 1,
  pageSize: 10,
  total: 0,
};
